import React from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import Hero from '@/components/home/Hero';
import ServicesPreview from '@/components/home/ServicesPreview';
import WhyChooseUs from '@/components/home/WhyChooseUs';
import CTASection from '@/components/home/CTASection';

const Home = () => {
  return (
    <PageWrapper>
      <Hero />
      <ServicesPreview />
      <WhyChooseUs />
      <CTASection />
    </PageWrapper>
  );
};

export default Home;